import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Parallax } from "react-parallax";
import { format } from 'date-fns';
import { FaChild  } from "react-icons/fa";
import ModalParticipantes from './ModalParticipantes';

const EventoTopo = ({ evento }) => {

    const [showModal, setShowModal] = useState(false);
    const [modalidadeEvento, setModalidadeEvento] = useState(null);

    return(
        <>
            <Parallax className="p-0" bgImage={evento.foto} strength={300}> 
                <div className="spacer-30"></div>
                <div className="container position-relative ">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="spacer-30"></div>
                            <div className="col-lg-12 col-md-6 mb-sm-20" >
                            <div className="spacer-150"></div>
                            </div>
                            <div className="spacer-60"></div>
                        </div>
                        <div className="spacer-60"></div>
                    </div>
                    <div className="spacer-150"></div>
                </div>
            </Parallax>
            <div className="container position-relative ">
                <h2 className="wow fadeInUp" data-wow-delay=".2s">{evento.nome}</h2>
                <div className="spacer-30"></div>
                <h3 className="wow fadeInUp" data-wow-delay=".4s">{evento.sobre}</h3>
                <div className="spacer-30"></div>
                <p className="wow fadeInUp">
                    {evento.dataEvento && !isNaN(new Date(evento.dataEvento).getTime())
                    ? 'Data do Evento ' + format(new Date(evento.dataEvento), 'dd/MM/yyyy')
                    : ''}
                    {/* BOTÕES */}
                    {
                        evento.tipoEvento === 2 &&
                        <div className="wow fadeInUp d-flex gap-3 flex-wrap" data-wow-delay=".5s">
                            <button
                                type="button"
                                onClick={() => {
                                    setModalidadeEvento('cursoSeminario');
                                    setShowModal(true);
                                }}
                                className="btn btn-primary d-flex align-items-center gap-2"
                            >
                                <FaChild  size={18} />
                                Participantes
                            </button>
                        </div>
                    }
                    {
                        evento.tipoEvento !== 2 &&
                        <div className="wow fadeInUp d-flex gap-3 flex-wrap" data-wow-delay=".5s">
                            <button
                                type="button"
                                onClick={() => {
                                    setModalidadeEvento('gyeorugi');
                                    setShowModal(true);
                                }}
                                className="btn btn-primary d-flex align-items-center gap-2"
                            >
                                <FaChild  size={18} />
                                Participantes Gyeorugi
                            </button>
                        
                            <button
                                type="button"
                                onClick={() => {
                                    setModalidadeEvento('poomsae');
                                    setShowModal(true);
                                }}
                                className="btn btn-secondary d-flex align-items-center gap-2"
                            >
                                <FaChild  size={18} />
                                Participantes Poomsae
                            </button>
                            {evento.edital &&
                                <Link 
                                    to={`${evento.edital}`}
                                    target='_blank'
                                    className="btn btn-subscribe d-flex align-items-center gap-2">
                                    Edital
                                </Link>
                            }
                        </div>
                    }
                </p>
            </div>
            <ModalParticipantes
                show={showModal} 
                onClose={() => setShowModal(false)}
                evento={evento}
                modalidadeEvento={modalidadeEvento}
            />
        </>
    );
}

export default EventoTopo;